import { Checkbox } from '@chakra-ui/react';
import styled from 'styled-components';

export const CheckboxStyled = styled(Checkbox)`
  .chakra-checkbox {
    &__control {
      width: 20px;
      height: 20px;
      border-radius: 6px!important;

      &:not([data-checked]):hover {
        border-color: 1px solid #01ad6e!important;
      }

      &:hover {
        border-color: 1px solid  #01ad6e!important;
      }

      &[data-checked] {
        background-color: #d8fff1;
        border-color: #01ad6e!important;

        &:hover {
          background-color: transparent;
        }

        svg {
          stroke: #01ad6e!important;
        }
      }
    }
  }
`;
